import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function singaporeCrowdfunding(){
  return(
   <div className="post-1490 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner asx-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar" />            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">Singapore crowdfunding platform CoAssets lists on ASX</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>5 September 2016</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>156 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>(MON, SEP 05, 2016 – 10:25 AM – http://www.businesstimes.com.sg/companies-markets/singapore-crowdfunding-platform-coassets-lists-on-asx )</p>
<p>SINGAPORE-BASED real estate and debt crowdfunding platform CoAssets on Monday announced that it has listed on the Australian Securities Exchange (ASX), after raising AS$6.55 million (S$6.72 million) in its initial public offering (IPO) at an issue price of A$0.40 per share.</p>
<p>The company, which was previously listed on the National Stock Exchange (NSX), is estimated to have a market capitalisation of A$66 million on ASX.</p>
<p>CoAssets said that the Australian listing provides the “market value” it needs to expand in the Asia-Pacific region, and to drive investor awareness about crowdfunding and the platform.</p>
<p>It intends to use the funds raised on marketing, managing intellectual property and product development. These will be managed through its Singapore headquarters, said CoAssets.</p>
<div className="related_article_bottom">
<div className="view view-more view-id-more view-display-id-related_articles related-articles view-dom-id-09eadf144ecccc0d16e0f3f6926b436d">
<div className="view-content">
<div className="views-row views-row-1 views-row-odd views-row-first views-row-last"></div>
</div>
</div>
</div>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=Singapore crowdfunding platform CoAssets lists on ASX&amp;url=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/&amp;title=Singapore crowdfunding platform CoAssets lists on ASX&amp;summary=(MON, SEP 05, 2016 – 10:25 AM – http://www.businesstimes.com.sg/companies-markets/singapore-crowdfunding-platform-coassets-lists-on-asx ) SINGAPORE-BASED real estate and debt crowdfunding platform CoAssets on Monday announced that it has listed on the Australian Securities Exchange (ASX), after raising AS$6.55 million (S$6.72 million) in its initial public offering (IPO) at an issue price of A$0.40 per share. The company, which was&amp;source=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/singapore-crowdfunding-platform-coassets-lists-on-asx/&amp;description=(MON, SEP 05, 2016 – 10:25 AM – http://www.businesstimes.com.sg/companies-markets/singapore-crowdfunding-platform-coassets-lists-on-asx ) SINGAPORE-BASED real estate and debt crowdfunding platform CoAssets on Monday announced that it has listed on the Australian Securities Exchange (ASX), after raising AS$6.55 million (S$6.72 million) in its initial public offering (IPO) at an issue price of A$0.40 per share. The company, which was&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
       
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/singapore_crowdfunding_platform.js